import * as d3 from "d3";
import { appendLineTooltip } from "./functions";

export function draw(container, data, config, palette, selection) {
  const cwidth = container.clientWidth;
  const cheight = container.clientHeight;

  const {
    axes,
    circle,
    header,
    layout,
    refLine,
    svg: svgx,
    tooltips,
    triangle: trianglex,
  } = config;

  const marginBottom = layout.margin.bottom;
  const marginLeft = layout.margin.left;

  const svg = d3.select(container);
  svg.selectAll("g").remove();

  if (data) {
    /** d3 margin convention */
    const width = cwidth - marginLeft - layout.margin.right;
    const height = cheight - layout.margin.top - marginBottom;
    /** SVG Styles */
    svg.style("background-color", svgx.Background);
    if (svgx.border) {
      svg.style("border", svgx.border);
    }

    if (header) {
      const headerGroup = svg.append("g");

      headerGroup
        .append("text")
        .attr("y", header.margin.top)
        .attr("x", header.margin.left)
        .attr("fill", header.colour)
        .style("text-anchor", "left")
        .style("font-size", header.fontSize)
        .style("font-weight", header.fontWeight)
        .text(header.text);
    }

    const layoutGroup = svg
      .append("g")
      .attr("class", "layoutgroup")
      .attr(
        "transform",
        "translate(" + marginLeft + "," + layout.margin.top + ")"
      );

    const xScale = d3.scaleLinear().domain([-12, 12]).range([0, width]);

    const yScale = d3
      .scaleLinear()
      .domain(d3.extent(data.map((item) => item[selection])))
      .range([height, 0]);

    /* Add Axis into SVG */
    const xAxis = d3
      .axisBottom(xScale)
      .ticks(12)
      .tickSizeInner(axes.x.tickSizeInner);
    const yAxis = d3
      .axisLeft(yScale)
      // .ticks(12)
      .tickSizeInner(axes.y.tickSizeInner)
      .tickFormat(function (d) {
        return `${d3.format(axes.y.format)(d)}%`;
      });

    const averageY = d3.mean(data.map((d) => d[selection]));
    const averageX = d3.mean(data.map((d) => d["V-Score"]));

    const xAxisGroup = svg
      .append("g")
      .attr("class", "x axis")
      .attr(
        "transform",
        `translate(${marginLeft}, ${height + layout.margin.top})`
      )
      .call(xAxis);

    if (axes.x.label) {
      xAxisGroup
        .append("text")
        .attr(
          "transform",
          "translate(" + width / 2 + " ," + axes.x.label.margin + ")"
        )
        .style("text-anchor", "middle")
        .style("fill", axes.x.label.colour)
        .style("font-size", axes.x.label.fontSize)
        .style("font-weight", axes.x.label.fontWeight)
        .text(axes.x.label.text);
    }

    const yAxisGroup = svg
      .append("g")
      .attr("class", "y axis")
      // .call(yAxis)
      .attr(
        "transform",
        `translate(${marginLeft + axes.y.offset}, ${layout.margin.top})`
      );

    yAxisGroup
      .append("rect")
      .attr("x", 0 - axes.y.background.offset.x)
      .attr("y", 0 - axes.y.background.offset.y)
      .attr("width", axes.y.background.offset.x)
      .attr("height", height + axes.y.background.offset.y * 2)
      .style("fill", axes.y.background.selectedColor);

    yAxisGroup.call(yAxis);

    if (axes.y.label) {
      yAxisGroup
        .append("text")
        .style("text-anchor", "middle")
        .style("fill", axes.y.label.colour)
        .style("font-size", axes.y.label.fontSize)
        .style("font-weight", axes.y.label.fontWeight)
        .text(axes.y.label.text)
        .attr(
          "transform",
          "translate(" + axes.y.label.margin + "," + height / 2 + ")rotate(-90)"
        );
    }

    // .attr("transform", "translate(480,480)scale(23)rotate(180)")

    svg.selectAll(".x .domain").style("stroke", axes.x.domainColour);
    svg.selectAll(".x .tick line").style("stroke", axes.x.tickLineColour);
    svg.selectAll(".x .tick text").style("fill", axes.x.textColour);
    svg.selectAll(".x .tick text").style("font-size", axes.x.fontSize);
    svg.selectAll(".x .tick text").style("font-weight", axes.x.fontWeight);
    svg.selectAll(".y .domain").style("stroke", axes.y.domainColour);
    svg.selectAll(".y .tick line").style("stroke", axes.y.tickLineColour);
    svg.selectAll(".y .tick text").style("fill", axes.y.textColour);
    svg.selectAll(".y .tick text").style("font-size", axes.y.fontSize);
    svg.selectAll(".y .tick text").style("font-weight", axes.y.fontWeight);

    layoutGroup
      .append("line")
      .attr("y1", yScale(averageY))
      .attr("y2", yScale(averageY))
      .attr("x1", xScale(-12))
      .attr("x2", xScale(12))
      .style("stroke", refLine.stroke)
      .style("stroke-width", refLine.strokeWidth);

    if (refLine.label.y.text) {
      layoutGroup
        .append("text")
        .attr("transform", "translate(" + 0 + " ," + yScale(averageY) + ")")
        .attr("dy", "-0.5em")
        .style("text-anchor", "start")
        .style("fill", refLine.label.x.color)
        .style("font-size", refLine.label.x.fontSize)
        .style("font-weight", refLine.label.x.fontWeight)
        .text(refLine.label.x.text);
    }

    layoutGroup
      .append("line")
      .attr("y1", 0)
      .attr("y2", height)
      .attr("x1", xScale(averageX))
      .attr("x2", xScale(averageX))
      .style("stroke", refLine.stroke)
      .style("stroke-width", refLine.strokeWidth);

    if (refLine.label.x.text) {
      layoutGroup
        .append("text")
        .attr(
          "transform",
          "translate(" + xScale(averageX) + " ," + height + ")rotate(-90)"
        )
        .attr("dy", "-0.5em")
        .style("text-anchor", "start")
        .style("fill", refLine.label.x.color)
        .style("font-size", refLine.label.x.fontSize)
        .style("font-weight", refLine.label.x.fontWeight)
        .text(refLine.label.x.text);
    }

    const onMouseover = (x, y, d) => {
      tooltipgroup.style("display", "block");
      tooltipgroup.select(".table-ticker").html(d.Ticker);
      tooltipgroup.select(".table-modelDate").html(d.ModelDate);
      tooltipgroup
        .select(".table-horizon")
        .html(`${(+d.Horizon.trim()).toFixed(0)}d`);
      tooltipgroup.select(".table-fwd-horizon-ret").html(`${d.FwdPxRet}`);
      tooltipgroup
        .select(".table-selection")
        .html(`${d[selection].toFixed(2)}%`);

      const pdiv = tooltipgroup.select(".parentdiv").node();
      const pdivwidth = pdiv.getBoundingClientRect().width;
      const pdivheight = pdiv.getBoundingClientRect().height;
      const xw = tooltips.box.width - pdivwidth;

      const tx = x - tooltips.box.width / 2;
      const ctx = x - pdivwidth / 2;

      const onTop = () => {
        const ty = y - tooltips.box.height - tooltips.triangle.mousetoboxgap;

        const ctp = tx + xw / 2;

        const allowedwidth = width - pdivwidth;
        const xdiff =
          ctp < 0
            ? ctp * -1 - layout.margin.left / 2
            : ctx > allowedwidth
            ? allowedwidth - tx - xw / 2 + layout.margin.right / 2
            : 0;

        const ydiff = tooltips.box.height - pdivheight;

        tooltipgroup.attr(
          "transform",
          "translate(" + (tx + xdiff) + "," + (ty + ydiff) + ")"
        );

        // tooltiparrow
        //   .style("display", "block")
        //   .attr("transform", "translate(" + tx + "," + ty + ")");
      };
      const atBottom = () => {
        const ty = y; //- tooltips.triangle.mousetoboxgap;

        const ctp = tx + xw / 2;
        const allowedwidth = width - pdivwidth;
        const xdiff =
          ctp < 0
            ? ctp * -1 - layout.margin.left / 2
            : ctx > allowedwidth
            ? allowedwidth - tx - xw / 2 + layout.margin.right / 2
            : 0;

        const ydiff = tooltips.box.height - pdivheight;

        tooltipgroup.attr(
          "transform",
          "translate(" + (tx + xdiff) + "," + (ty + ydiff) + ")"
        );
      };
      if (y + 70 > pdivheight) {
        onTop();
      } else {
        atBottom();
      }
    };

    /*****CIRCLES ******/
    const circleGroup = layoutGroup
      .selectAll(".circlegroup")
      .data(data.filter((d) => d.RiskModel === "Sigma"))
      .enter()
      .append("g")
      .attr("class", "circlegroup")
      .attr(
        "transform",
        (d) =>
          "translate(" + xScale(d["V-Score"]) + "," + yScale(d[selection]) + ")"
      )
      .on("mouseover", function (e, d) {
        const element = d3.select(this);
        const val = element.attr("transform").split(/[\s,()]+/);
        const x = parseFloat(val[1]);
        const y = parseFloat(val[2]);
        onMouseover(x, y, d);
        const circle = element.select("circle");
        circle.style("fill", tooltips.hovercolour);
      })
      .on("mouseout", function (e) {
        tooltipgroup.style("display", "none");
        tooltiparrow.style("display", "none");
        const element = d3.select(this);
        const circle = element.select("circle");
        circle.style("fill", "transparent");
      });

    circleGroup
      .append("circle")
      .attr("cx", 0)
      .attr("cy", 0)
      .attr("r", circle.radius)
      .style("stroke", (d) => palette[d.Ticker])
      .style("stroke-width", circle.strokeWidth)
      .style("fill", "transparent")
      .style("cursor", "pointer");

    /*****TRIANGLES ******/
    const triangleGroup = layoutGroup
      .selectAll(".triangleGroup")
      .data(data.filter((d) => d.RiskModel === "Vector"))
      .enter()
      .append("g")
      .attr("class", "triangleGroup")
      .attr(
        "transform",
        (d) =>
          "translate(" + xScale(d["V-Score"]) + "," + yScale(d[selection]) + ")"
      )
      .on("mouseover", function (e, d) {
        const element = d3.select(this);
        const val = element.attr("transform").split(/[\s,()]+/);
        const x = parseFloat(val[1]);
        const y = parseFloat(val[2]);
        onMouseover(x, y, d);
        const triangle = element.select("path");
        triangle.style("fill", tooltips.hovercolour);
      })
      .on("mouseout", function (e) {
        tooltipgroup.style("display", "none");
        tooltiparrow.style("display", "none");
        const element = d3.select(this);
        const triangle = element.select("path");
        triangle.style("fill", "transparent");
      });

    var triangle = d3.symbol().type(d3.symbolTriangle).size(trianglex.size);

    triangleGroup
      .append("path")
      .attr("d", triangle)
      .style("stroke", (d) => palette[d.Ticker])
      .style("stroke-width", 1)
      .style("fill", "transparent")
      .style("cursor", "pointer")
      .attr("transform", "rotate(90)");

    const tooltiparrow = layoutGroup.append("g").style("display", "none");
    const tooltipgroup = layoutGroup.append("g").style("display", "none");

    const foreignObject = tooltipgroup
      .append("foreignObject")
      .attr("x", 0)
      .attr("y", 0)
      .attr("width", tooltips.box.width)
      .attr("height", tooltips.box.height)
      .style("pointer-events", "none");

    const aparentdiv = foreignObject
      .append("xhtml:div")
      .style("display", "flex")
      .style("justify-content", "center");

    const parentdiv = aparentdiv
      .append("xhtml:div")
      .attr("class", "parentdiv")
      .style("height", "100%")
      .style("display", "inline-block")
      .style("justify-content", "center")
      .style("background-color", tooltips.box.fill)
      .style("border-radius", tooltips.box.radius + "px")
      .style(
        "border",
        `${tooltips.box.strokeWidth}px solid ${tooltips.box.stroke}`
      )
      .style("padding", `${tooltips.table.padding}px`);

    const table = parentdiv
      .append("xhtml:table")
      .style("background-color", tooltips.table.backgroundColor)
      .style("border-collapse", "collapse")
      .style("border", tooltips.table.border);
    const tbody = table.append("xhtml:tbody");

    appendLineTooltip(tbody, tooltips, "Ticker", "table-ticker");
    appendLineTooltip(tbody, tooltips, "Model Date", "table-modelDate");
    appendLineTooltip(tbody, tooltips, "Horizon", "table-horizon");
    appendLineTooltip(
      tbody,
      tooltips,
      "Fwd Horizon Ret",
      "table-fwd-horizon-ret"
    );
    appendLineTooltip(tbody, tooltips, selection, "table-selection");

    tooltiparrow
      .append("path")
      .attr(
        "d",
        d3.symbol().type(d3.symbolTriangle).size(tooltips.triangle.size)
      )
      .attr("fill", tooltips.box.fill)

      .style("stroke", tooltips.box.stroke)
      .style("stroke-width", tooltips.box.strokeWidth)
      .attr(
        "transform",
        "translate(" +
          tooltips.box.width / 2 +
          "," +
          (tooltips.box.height + tooltips.triangle.marginTop) +
          ")rotate(180)"
      );
  }
}
